<div class="container" *ngIf="historicalPriceModel && priceModel">
  <div>
    <div>
      <h5 class="heading rps-heading-five">Historical prices</h5>
    </div>
  </div>

  <div class="container" *ngIf="priceModel">
    <div *ngIf="priceModel.profile.fundFact.isMoneyMarket" [innerHtml]="moneyMarket">
    </div>
  </div>
  <!-- d-none d-md-block d-lg-block -->
  <div class="container d-none d-sm-block" *ngIf="priceModel">
    <div class="row"
      *ngIf="(priceModel.profile.isETF || priceModel.profile.isMutualFund || priceModel.profile.is529) && !priceModel.profile.fundFact.isMoneyMarket">
      <div class="tab-grp">
        <div class="tabset-container">
          <c11n-tabs [activeItem]="selected.value" (activeItemChange)=onTabChange($event)
                     variant="left-aligned" overflowOption="nav-overflow" hasAnimation="false"
                     dynamicHeight disablePagination="true">
            <c11n-tab-panel *ngFor="let model of historicalPriceModel;let i = index" [id]="i" role="tablist"
                            aria-label={{model.label}} [labelText]="model.label" [attr.data-rpa-tag-id]="'pr-hp-tab-' + model.label">
                <app-one-month [modelLabel]="model.label"  *ngIf="selected.value === i" [data]="historicalPriceModel[i].element"
                               [profileData]="priceModel?.profile" [priceHistorySearchUrl]="priceHistorySearchUrl">
                </app-one-month>
            </c11n-tab-panel>
          </c11n-tabs>
        </div>
      </div>
    </div>
  </div>

  <!-- d-lg-none d-xl-block -->
  <div class="d-block d-sm-none">
    <p class="price-chart-unavailable-mobile rps-paragraph-two">This chart can’t be displayed on mobile devices. For the best viewing
      experience, visit this page from your desktop or laptop.</p>
  </div>
</div>
